import styled from 'styled-components'

export const Container = styled.div`
  margin-bottom: 16px;
  font-weight: 500;
  .small, small {
    font-size: 14px;
    line-height: 1.57;
  }
  .weight-600 {
    font-weight: 600;
  }
  .li-farm{
    width: 100%;
    margin: 0 auto;
    padding: 15px;
    border-radius: 16px;
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    background-color: #252833;
    .li-farm-content{
      display: flex;
      width: 90%;
      flex-wrap: wrap;
      align-items: center;
      .li-farm-tr{
        display: flex;
        justify-content: space-between;
        align-items: center;
      }
      .li-farm-tr-small{
        width: 20%;
      }
      .li-farm-tr-medium{
        width: 30%;
      }
      .flex-start{
        justify-content: flex-start;
      }
      .doubleCurrencyLogo{
        position: relative;
        display: flex;
        align-items: center;
        margin-right: 10px;
        height: 43px;
        .currencyLogo{
          display: flex;
          justify-content: center;
          align-items: center;
          overflow: hidden;
          width: 30px;
          height: 30px;
          border-radius: 30px;
        }
      }
      .doubleCurrencyLogo>div:first-child {
          z-index: 2;
          margin-right: -4px;
      }
      .text-secondary{
        display:none;
      }
    }
  }
  .only-mobile{
    display:none !important;
  }
  .li-farm-button{
    width: 10%;
    button{
      width:100%;
      padding: 10px 0;
      background-color: var(--secondaryColor);
      border-radius: 10px;
      border: none;
      color: var(--primaryColor);
      font-size: 16px;
      font-weight: bold;
      transition: all 0.3s;
      &:hover{
        opacity: 0.8;
      }
    }
  }
  @media screen and (max-width: 700px) {
    .li-farm-button{
      width: 100%;
    }
    .li-farm-content{
      width: 100% !important;
    }
    .li-farm-tr{
      width: 100% !important;
      margin-bottom: 8px;
    }
    .text-secondary{
      display:block !important;
    }
    .only-mobile{
      display: flex !important;
    }
    .reward-aling{
      text-align: end;
    }
  }
`